import api from '../utils/api';


export const submitReview = (review) => {
    let url = `/api/reviews/add-review`;
    return api.post(url, review)
}
export const getReviewerTypes = () => {
    let url = `/api/reviews/get-reviewer-types`;
    return api.get(url);
}

//V2
export const getAllReviews = (filter) => {
    const data = { ...filter };
    return api.post('/api/reviews/get-all-reviews', data);
}

export const updateReviewStatus = (baseId, status) => {
    return api.post(`/api/reviews/update-status/${baseId}/${status}`);
};

export const UpdateSchoolVerified = (baseId, status) => {
    return api.post(`/api/reviews/update-school-status/${baseId}/${status}`);
};

export const getProductReviews = (filter) => {
    return api.post('/api/reviews/filter', filter);
} 

export const getReviewProductDetails = (baseId) => {
    return api.post(`/api/reviews/details/${baseId}`);
};